export const getCountryParam = (defaultCountry = 'germany') => {
  const locale = new RegExp(`_?country=([a-z_]*)`);
  const results = locale.exec(location.search);
  if (results) {
    return results[1];
  }
  return defaultCountry;
};

export default getCountryParam;
